<template>
    <div className=" w-[45%] py-[15px] mx-auto">
        <div class=" text-[20px] font-normal px-[25px] text-black text-center">
            Demande prêt/Avance
        </div>
        <div class="text-black px-[25px] mt-4 text-[14px] font-extralight text-center">
            Les champs du formulaire suivis d'un <span class="text-[#f44545]">*</span> sont obligatoire. veuillez lire le formulaire
            avant soummition
        </div>
        <form @submit.prevent="submitForm" class="px-[25px] text-black mt-4">
            <div class="w-full flex flex-col items-start mt-2">
                <label for="motif" class="font-extralight" >Motif<span class="text-[#f44545]">*</span></label>
                    <select v-model="formdata.type" name="motif" id="motif" class="h-[40px] w-full rounded-md border outline-none p-3 focus:outline-none bg-[#f9fafb] cursor-pointer">
                        <option >Choisissez le motif</option>
                        <option value="pret">
                            Prêt
                        </option>
                        <option value="avance">
                            Avance
                        </option>
                    </select>
            </div>
            <div v-if="isAvance" class="w-full flex items-center justify-between pt-4 text-black">
                        <div class="w-full flex flex-col items-start ">
                            <label for="month" class="font-light" >Choisir le mois<span class="text-[#f44545]">*</span></label>
                            <input v-model="formdata.month" type="month" name="month" class="h-[40px] w-full rounded-md border outline-none bg-[#f9fafb] p-3 focus:outline-none">
                        </div>
            </div>
            <div v-else class="w-full flex items-center justify-between pt-4 text-black">
                        <div class="w-full flex flex-col items-start ">
                            <label for="echeances" class="font-light" >Echéance<span class="text-[#f44545]">*</span></label>
                            <input v-model="formdata.echeances" type="number" min="0" name="echeances" class="h-[40px] w-full rounded-md border outline-none bg-[#f9fafb] p-3 focus:outline-none">
                        </div>
            </div>
            <div class="w-full flex items-center justify-between pt-4 text-black">
                <div class="w-full flex flex-col items-start ">
                    <label for="amount" class="font-light" >Montant<span class="text-[#f44545]">*</span></label>
                    <input type="number" v-model="formdata.amount" min="0" class="h-[40px] w-full rounded-md border outline-none bg-[#f9fafb] p-3 focus:outline-none">
                </div>
            </div>
            <div class="w-full flex flex-col items-start mt-2">
                        <label for="detail" class="font-extralight">Commentaire<span class="text-[#f44545]">*</span></label>
                        <textarea name="detail" v-model="formdata.comment" id="" class="rounded-md bg-[#f9fafb] border p-5 h-[25vh] w-full"></textarea>
            </div>
            <div className="w-full mt-4 gap-x-3 flex items-center justify-end">
                <button type="submit" :disabled="asSend" class="w-full py-3 bg-[#5357ec] text-white rounded-md">
                    <Loader2 v-if="asSend" class="animate-spin mx-auto"/>
                    <span v-if="!asSend">Enregistrer</span>
                </button>
            </div>
        </form>
    </div>
</template>
<script>
import toast from "../ui/toast";
import API from "@/service/API.js";
import {
    Loader2
} from "lucide-vue-next";
export default {
    name: "PretAvance",
    components:{
        Loader2
    },
    data(){
        return {
            asSend:false,
            formdata:{
                type:"pret",
                comment:"",
                amount:0,
                month:null,
                echeances:null,
            }
        }
    },
    computed:{
        isAvance(){
            return this.formdata.type == 'avance'
        }
    },
    methods:{
        resetForm(){
            this.formdata = {
                type:"pret",
                comment:"",
                amount:0,
                month:null,
                echeances:null,
            }
        },
        submitForm(){
            this.asSend = true;
            const {type,echeances,month,comment,amount} = this.formdata;
            const formData = new FormData();
            formData.append("type",type);
            formData.append("comment",comment);
            type == "avance" && formData.append("month", month);
            formData.append("amount", amount);
            type == "pret" && formData.append("echeances", echeances);
            formData.append("user_id", localStorage.getItem("userId"));

            API.post("advances",formData)
            .then((response)=>{
                if(response.data["status"]){
                    toast.success("Succes","Heure sup Enregistré, à bientôt",3000);
                    this.resetForm();
                }else{
                    toast.error("Echèc",response.data["message"],5000)
                }
            })
            .catch(()=>{
                console.log("erreur sur serveur!!!!!")
            })
            .finally(()=>{
                this.asSend = false;
            })
        }
    }
}
</script>
